/** @format */

import React, { FunctionComponent } from 'react'
import styled from 'styled-components'

interface Props {
  color?: string
  className?: any
  text?: number
}
const PinText: FunctionComponent<Props> = ({ className, color, text }) => {
  return (
    <span className={className} color={color}>
      {text > 99999 ? '99999+' : text}
    </span>
  )
}

export default styled(PinText)`
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-left: 8px;
  ::before {
    content: ' ';
    position: absolute;
    height: 6px;
    width: 6px;
    border-radius: 3px;
    top: 50%;
    left: 0;
    transform: translateY(-50%) translateX(-50%);
    background: ${props => (props.color ? props.color : '#0091ea')};
  }
`
